module.exports = __webpack_public_path__ + "static/media/commercial.533ea47b.svg";